import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-cifris26',
  templateUrl: './home-cifris26.component.html',
  styleUrls: ['./home-cifris26.component.css']
})
export class HomeCifris26Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
